var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_68840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2857 4.00002C10.2857 3.68443 10.5415 3.42859 10.8571 3.42859H15.4286C15.7442 3.42859 16 3.68443 16 4.00002V8.57145C16 8.88704 15.7442 9.14287 15.4286 9.14287C15.113 9.14287 14.8571 8.88704 14.8571 8.57145V4.57145H10.8571C10.5415 4.57145 10.2857 4.31561 10.2857 4.00002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8326 3.59596C16.0558 3.81911 16.0558 4.18092 15.8326 4.40408L9.37549 10.8612L9.37143 10.8652C9.1578 11.0746 8.87058 11.1919 8.57143 11.1919C8.27228 11.1919 7.98506 11.0746 7.77143 10.8652L7.76737 10.8612L5.14286 8.23671L0.97549 12.4041C0.752333 12.6272 0.390524 12.6272 0.167368 12.4041C-0.0557892 12.1809 -0.0557892 11.8191 0.167368 11.596L4.3388 7.42453L4.34286 7.42051C4.55649 7.21111 4.84371 7.09381 5.14286 7.09381C5.442 7.09381 5.72922 7.21111 5.94286 7.42051L5.94692 7.42453L8.57143 10.049L15.0245 3.59596C15.2477 3.3728 15.6095 3.3728 15.8326 3.59596Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_68840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArrowUp);
export default __webpack_public_path__ + "static/media/chart-arrow-up.ca833761dc579428bb3408da9d7aa4a1.svg";
export { ForwardRef as ReactComponent };